import useRegister from '~/utils/GraphQL/hooks/useRegister';

export default function GraphQLRegister({ children }) {
    useRegister();
    return children;
}
